export default [{
    path: '/references/sale-offices',
    name: 'sale-offices',
    component: () => import('@/views/modules/References/saleOffices.vue'),
    meta: {
      breadcrumb: [{
        text: 'navbars.sales_departments',
        active: false,
      }, ],
      unique_name: "references-sale-offices"
    },
  },
  {
    path: '/references/constructors',
    name: 'constructors',
    component: () => import('@/views/modules/References/constructors.vue'),
    meta: {
      breadcrumb: [{
        text: 'navbars.developers',
        active: false,
      }, ],
      unique_name: "references-constructors"
    },
  },
  {
    path: '/references/contract-templates',
    name: 'contract-templates',
    component: () => import('@/views/modules/References/contractTemplates.vue'),
    meta: {
      breadcrumb: [{
        text: 'navbars.contract_templates',
        active: false,
      }, ],
      unique_name: "references-contract-templates"
    },
  },
  {
    path: '/references/contract-templates/:id/edit',
    name: 'contract-template-edit',
    component: () => import('@/views/modules/References/addOrEditTemplate.vue'),
    props: {
      isEdit: true,
    },
    meta: {
      is_dynamic_route: true,
      breadcrumb: [{
          text: 'navbars.contract_templates',
          to: '/references/contract-templates',
          active: false,
        },
        {
          text: '',
          active: true,
        },
      ],
      unique_name: "references-contract-templates"
    },
  },
  {
    path: '/references/contract-templates/add',
    name: 'contract-template-add',
    component: () => import('@/views/modules/References/addOrEditTemplate.vue'),
    props: {
      isEdit: false,
    },
    meta: {
      breadcrumb: [{
          text: 'navbars.contract_templates',
          to: '/references/contract-templates',
          active: false,
        },
        {
          text: 'navbars.contract_template_add',
          active: true,
        },
      ],
      unique_name: "references-contract-templates"
    },
  },
  {
    path: '/references/project-staff',
    name: 'project-staff',
    component: () => import('@/views/modules/References/projectStaff.vue'),
    meta: {
      breadcrumb: [{
        text: 'navbars.project_staff',
        active: true,
      }, ],
      unique_name: "references-project-staff"
    },
  },
]